import { AthosRecommendProvider } from '../../fetchers/recommend'
import { BeaconAnalyticsProvider } from '../../hooks/useBeaconAnalytics'
import { parseCarouselSettings, parseCardSettings } from '../../helpers/recommendation-settings.mjs'
import { getCardStyle } from '../card-styles'
import { useCartProductIds } from './useCartProductIds'

// The provider reads its options once on mount, so a changed seed remounts it by key to refetch.
export function RecommendationWrapper({ children, profile, productId, limit }) {
  return (
    <AthosRecommendProvider
      key={`${profile}|${limit}|${productId}`}
      profile={profile}
      productId={productId}
      limit={limit}
    >
      <BeaconAnalyticsProvider profile={profile}>{children}</BeaconAnalyticsProvider>
    </AthosRecommendProvider>
  )
}

export function ProductRecommendation({
  profile,
  productId,
  itemClass,
  carouselSettings = {},
  productCardSettings,
  limit,
  card,
  component: Component
}) {
  const cartIds = useCartProductIds()
  // A PDP passes its own product; everywhere else the cart seeds the profile.
  const seedIds = productId || cartIds

  const options = parseCarouselSettings(carouselSettings)
  const cardSettings = parseCardSettings(productCardSettings)
  const { CardComponent, SkeletonComponent } = getCardStyle(card)

  if (!profile) return null

  return (
    <RecommendationWrapper profile={profile} productId={seedIds} limit={limit}>
      <Component
        className={itemClass}
        options={options}
        productCardSettings={cardSettings}
        CardComponent={CardComponent}
        SkeletonComponent={SkeletonComponent}
      />
    </RecommendationWrapper>
  )
}

export function withRecommendationProvider(Component) {
  return function WrappedRecommendation(props) {
    return <ProductRecommendation {...props} component={Component} />
  }
}
